<script>
  import { ShowInfoModal, InfoDetail } from "../../stores";
  import { fly, fade } from "svelte/transition";

  $: if ($ShowInfoModal) {
    setTimeout(() => {
      $ShowInfoModal = false;
    }, 3000);
  }
</script>

{#if $ShowInfoModal}
  <div
    class="fixed top-[24px] right-[24px] w-auto h-auto bg-primary flex items-center z-max rounded-[6px] px-[18px] py-[4px]"
    in:fly={{ duration: 150, x: 100 }}
    out:fade={{ duration: 200 }}
  >
    <h3 class="font-medium text-[16px] my-4 text-white">
      {$InfoDetail}
    </h3>
  </div>
{/if}
